import { BenefitsRoutes, WalletRoutes } from 'components/lazy-routes.component';
import {
  FEATURE_FLAGS,
  BenefitsRedirectContainer,
  useTTVTracking,
} from '@highmark-web/highmark-common';
import { useFeatureFlagQuery } from '@leagueplatform/user-profile-api';

const springHealthRedirectOverrides = new Map([
  [
    '4843537072696e674541502d456c6967',
    '/additional-benefits/program-spring-health',
  ],
  [
    '4843537072696e672d456c696769626c',
    '/additional-benefits/program-spring-health',
  ],
  [
    '4843537072696e674865616c74684541',
    '/additional-benefits/program-spring-health',
  ],
  [
    '4843537072696e674865616c74682d45',
    '/additional-benefits/program-spring-health',
  ],
  [
    '4843537072696e674865616c74680000',
    '/additional-benefits/program-spring-health',
  ],
]);

export const AppBenefitsRoutes = () => {
  useTTVTracking();
  const { data: isBenefitsLandingMasonryV2Enabled } = useFeatureFlagQuery(
    FEATURE_FLAGS.ENABLE_BENEFITS_PAGE_2_0,
  );

  return isBenefitsLandingMasonryV2Enabled ? (
    <BenefitsRedirectContainer
      redirectOverrides={springHealthRedirectOverrides}
    >
      <BenefitsRoutes />
    </BenefitsRedirectContainer>
  ) : (
    <WalletRoutes />
  );
};
